import React, { FC, memo, useState, useEffect } from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  makeStyles
} from '@material-ui/core';
import { Editor } from '@tiptap/react';

const useStyles = makeStyles({
  root: { minWidth: 90 }
});

interface Props {
  editor: Editor | null;
}

const fontSizes = [
  '8',
  '9',
  '10',
  '11',
  '12',
  '14',
  '16',
  '18',
  '20',
  '22',
  '24',
  '26',
  '28',
  '32'
];

const FontSizeOption: FC<Props> = ({ editor }) => {
  const classes = useStyles();
  const [fontSize, setFontSize] = useState<string>('11');

  if (!editor) return null;

  // Update local state when selection changes
  useEffect(() => {
    const updateFontSize = () => {
      const activeSize =
        fontSizes.find((size) =>
          editor.isActive('textStyle', { fontSize: size })
        ) || '16'; //NOTE: default size of tiptap fonts
      setFontSize(activeSize);
    };

    editor.on('selectionUpdate', updateFontSize);

    updateFontSize();

    return () => {
      editor.off('selectionUpdate', updateFontSize);
    };
  }, [editor]);

  const handleChange = (e: React.ChangeEvent<{ value: any }>) => {
    const newSize = String(e.target.value);
    setFontSize(newSize);

    if (newSize) {
      editor
        .chain()
        .focus()
        .setMark('textStyle', { fontSize: newSize })
        .run();
    } else {
      editor
        .chain()
        .focus()
        .setMark('textStyle', { fontSize: null })
        .run();
    }
  };

  return (
    <FormControl className={classes.root} variant="outlined" size="small">
      <InputLabel shrink>Font Size</InputLabel>
      <Select
        value={fontSize}
        onChange={handleChange}
        label="Font Size"
        style={{ height: 35 }}
      >
        <MenuItem value="">
          <em>Default</em>
        </MenuItem>
        {fontSizes.map((size) => (
          <MenuItem key={size} value={size}>
            {size}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default memo(FontSizeOption);
